import i18n from '../i18n'

const regions = [
  {
    code: 'ALASKA',
    name: i18n.t('regions.alaska'),
    points: [
      { lat: 69.5686, lng: -138.9425 },
      { lat: 53.908, lng: -166.5514 },
    ],
  },
  {
    code: 'ARCTIQUE',
    name: i18n.t('regions.arctic'),
    points: [
      { lat: 79.9407, lng: 16.7922 },
      { lat: 60.5592, lng: -67.9435 },
      { lat: 72.7167, lng: -92.5333 },
      { lat: 71.0579, lng: -8.1613 },
    ],
  },
  {
    code: 'AMERNORD',
    name: i18n.t('regions.northAmerica'),
    points: [
      { lat: 43.0256, lng: -87.891 },
      { lat: 56.9593, lng: -133.9367 },
      { lat: 25.7821, lng: -80.1846 },
    ],
  },
  {
    code: 'EUNORBAL',
    name: i18n.t('regions.northEurope'),
    points: [
      { lat: 60.1654, lng: 24.9605 },
      { lat: 69.6476, lng: 18.9686 },
      { lat: 52.1098, lng: -10.2649 },
    ],
  },
  {
    code: 'EUSUDMED',
    name: i18n.t('regions.mediterranea'),
    points: [
      { lat: 33.6182, lng: -7.5841 },
      { lat: 41.024, lng: 28.9838 },
      { lat: 27.2625, lng: 33.8644 },
    ],
  },
  {
    code: 'ASIE',
    name: i18n.t('regions.asia'),
    points: [
      { lat: 43.199, lng: 141.0239 },
      { lat: -1.2482, lng: 103.7766 },
    ],
  },
  {
    code: 'MER_ROUGE',
    name: i18n.t('regions.redSea'),
    points: [
      { lat: 27.2625, lng: 33.8644 },
      { lat: 11.572076, lng: 43.145645 },
    ],
  },
  {
    code: 'CARAIBES',
    name: i18n.t('regions.caribbean'),
    points: [
      { lat: 17.885, lng: -71.7392 },
      { lat: 13.1088, lng: -59.6322 },
    ],
  },
  {
    code: 'AMERIQUE_CENTRALE',
    name: i18n.t('regions.centralAmerica'),
    points: [
      { lat: 7.8886, lng: -78.3808 },
      { lat: 19.432608, lng: -99.133209 },
    ],
  },
  {
    code: 'AMERIQUE_SUD',
    name: i18n.t('regions.southAmerica'),
    points: [
      { lat: -52.057, lng: -73.2641 },
      { lat: 11.2415, lng: -74.2212 },
    ],
  },
  {
    code: 'AFRIQUE',
    name: i18n.t('regions.africa'),
    points: [
      { lat: -33.918861, lng: 18.4233 },
      { lat: 5.1951, lng: 72.934 },
      // { lat: 25.2903, lng: 55.2611 },
    ],
  },
  {
    code: 'RIVAGES_ATLANTIQUES',
    name: i18n.t('regions.atlantic'),
    points: [
      { lat: 14.6837, lng: -17.3771 },
      { lat: 48.6405, lng: -2.0402 },
      // { lat: 25.2903, lng: 55.2611 },
    ],
  },
  {
    code: 'OCEANIE',
    name: i18n.t('regions.oceania'),
    points: [
      { lat: -43.8701, lng: -176.5082 },
      { lat: -2.5409, lng: 140.7135 },
      { lat: -7.7161, lng: 113.2146 },
      { lat: -14.9733, lng: -147.6367 },
    ],
  },
  {
    code: 'ANTARCTI',
    name: i18n.t('regions.antarctic'),
    points: [
      { lat: -51.0287, lng: -61.207 },
      { lat: -54.4688, lng: -37.0488 },
      { lat: -69.0434, lng: -69.5423 },
    ],
  },
]

export default regions
